function cov_1hnbf2rpkr() {
  var path = "/app/src/hooks/use-get-subvention.ts";
  var hash = "dbab1a1ea9160bd77ab43206b1cf174a83bf99a5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/hooks/use-get-subvention.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 32
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 7,
          column: 31
        },
        end: {
          line: 7,
          column: 46
        }
      },
      "2": {
        start: {
          line: 8,
          column: 18
        },
        end: {
          line: 8,
          column: 56
        }
      },
      "3": {
        start: {
          line: 10,
          column: 32
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "4": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 18,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 32
          },
          end: {
            line: 6,
            column: 33
          }
        },
        loc: {
          start: {
            line: 6,
            column: 38
          },
          end: {
            line: 19,
            column: 1
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 23
          }
        }, {
          start: {
            line: 11,
            column: 27
          },
          end: {
            line: 11,
            column: 29
          }
        }],
        line: 11
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 16,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 6
          },
          end: {
            line: 16,
            column: 42
          }
        }, {
          start: {
            line: 16,
            column: 46
          },
          end: {
            line: 16,
            column: 69
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "dbab1a1ea9160bd77ab43206b1cf174a83bf99a5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hnbf2rpkr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1hnbf2rpkr();
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { SUBVENTION_COUNTRY } from 'src/constants/subvention-country';
import { useAppContext } from 'src/context/store/app-provider';
import { getLongestSubventionPlan } from 'src/utils/get-longest-subvention-plan';
cov_1hnbf2rpkr().s[0]++;
export var useGetSubvention = function useGetSubvention() {
  var _ref2;
  cov_1hnbf2rpkr().f[0]++;
  var _ref = (cov_1hnbf2rpkr().s[1]++, useAppContext()),
    offers = _ref.offers,
    currency = _ref.currency;
  var country = (cov_1hnbf2rpkr().s[2]++, COUNTRY_NAME_BY_CURRENCY_MAP[currency]);
  var longestSubventionPlan = (cov_1hnbf2rpkr().s[3]++, getLongestSubventionPlan((_ref2 = (cov_1hnbf2rpkr().b[0][0]++, offers.installments)) !== null && _ref2 !== void 0 ? _ref2 : (cov_1hnbf2rpkr().b[0][1]++, [])));
  cov_1hnbf2rpkr().s[4]++;
  return {
    isSubvention: (cov_1hnbf2rpkr().b[1][0]++, SUBVENTION_COUNTRY.includes(country)) && (cov_1hnbf2rpkr().b[1][1]++, !!longestSubventionPlan),
    longestSubventionPlan: longestSubventionPlan
  };
};